<template>
  <el-dialog title="设置基础折扣特权" :visible.sync="dialogVisible" @close="$emit('update:visible',false)">
    <div class="dialog_conwrap">
      <el-form ref="form" :rules="rules" :model="formdata" label-width="220px">
        <el-form-item label="设定公司员工的基础特权折扣:" prop="discount">
          <el-input v-model.number="formdata.discount"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="save('form')">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import api from "@/api.js";
export default {
  name: "discountDialog",
  props: ["visible"],
  watch: {
    visible() {
      this.dialogVisible = this.visible;
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      formdata: {
        discount: ""
      },
      rules: {
        discount: [
          { required: true, message: "请输入基础特权折扣", trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    // 保存
    save(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.submitsave();
        } else {
          return false;
        }
      });
    },
    // 提交保存
    submitsave() {
      let params = {
        discount: this.formdata.discount
      };
      this.axios
        .post(api.discount_set_discount, params)
        .then(response => {
          if (response.data.code == 0) {
            this.$message({
              message: "设置成功",
            });
            this.$emit("discountsucess");
            this.dialogVisible = false;
          } else {
          }
        })
        .catch(() => {});
    }
  }
};
</script>

